import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetListForLoyaltyDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscountUserAbsences/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export { GetListForLoyaltyDetails };
